import React, { useEffect, useState } from 'react';
import { fetchHelpVideoBlob, youtubeEmbedUrl } from './helpApi';

const frameStyle = {
  width: '100%',
  aspectRatio: '16 / 9',
  border: '1px solid #E5E7EB',
  background: '#000',
  display: 'block',
};

function HelpVideoPlayer({ video }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!video || video.type !== 'upload' || !video.filename) return undefined;
    let objectUrl = null;
    let cancelled = false;
    setError('');
    setBlobUrl(null);
    fetchHelpVideoBlob(video.filename)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setError('Could not load the video.');
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [video]);

  if (!video) return null;

  if (video.type === 'youtube') {
    const embed = youtubeEmbedUrl(video.url);
    if (!embed) {
      return (
        <a href={video.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px' }}>
          Watch the video
        </a>
      );
    }
    return (
      <iframe
        title="Help video"
        src={embed}
        style={frameStyle}
        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        allowFullScreen
      />
    );
  }

  if (video.type === 'url') {
    return <video src={video.url} controls style={frameStyle} />;
  }

  if (error) return <p style={{ fontSize: '12px', color: '#DC2626' }}>{error}</p>;
  if (!blobUrl) return <p style={{ fontSize: '12px', color: '#6B7280' }}>Loading video…</p>;
  return <video src={blobUrl} controls style={frameStyle} />;
}

export default HelpVideoPlayer;
